/**
 * バリデーションメッセージのオブジェクト
 * @constant {object} cnMessages
 */
const cnMessages = {
    REQUIRED: '必填',
    REQUIRED_SELECT: '请选择',
    ANY_REQUIRED: '请输入任意一项',
    TEL: '请输入您的电话号码',
    MAIL: '请输入您的电子邮件地址',
    NUM: '请输入数字',
    ALPHABET: '请输入字母',
    ALPHA_NUM: '请输入字母或数字',
    ZIP: '请输入您的邮政编码',
    ADDR: '请输入您的地址',
    KANA: '请输入平假名或片假名',
    HIRAGANA: '请输入平假名',
    KATAKANA: '请输入片假名',
    NO_INPUT: '请输入',
};
export default cnMessages;
//# sourceMappingURL=cn.js.map